export default __webpack_public_path__ + "static/media/agent.27cd8f16.svg";